'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactI18next = require('react-i18next');

var _strings = require('helpers/strings');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouterRedux = require('react-router-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./Auth.scss');
// const defaultImage = require('assets/default-logo.png');


var Registration = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    activateAccountLoaded: state.auth.activateAccountLoaded,
    activateAccountLoading: state.auth.activateAccountLoading,
    loginData: state.auth.loginData,
    termsAccepted: state.auth.termsAccepted,
    user: state.auth.user
  };
}, (0, _extends3.default)({}, authActions, { pushState: _reactRouterRedux.push })), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(Registration, _Component);

  function Registration() {
    (0, _classCallCheck3.default)(this, Registration);
    return (0, _possibleConstructorReturn3.default)(this, (Registration.__proto__ || (0, _getPrototypeOf2.default)(Registration)).apply(this, arguments));
  }

  (0, _createClass3.default)(Registration, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          email = _props.loginData.email,
          pushState = _props.pushState;

      if (!email) {
        pushState('/');
      }
    }
  }, {
    key: 'activate',
    value: function activate() {
      var _props2 = this.props,
          email = _props2.loginData.email,
          activateAccount = _props2.activateAccount;

      activateAccount({ userEmail: email });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          t = _props3.t,
          loginData = _props3.loginData,
          activateAccountLoaded = _props3.activateAccountLoaded,
          activateAccountLoading = _props3.activateAccountLoading,
          termsAccepted = _props3.termsAccepted;


      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('homeContent', 'text-center', styles.auth) },
        _react2.default.createElement(
          'div',
          { className: styles.registration },
          loginData.email ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: styles.welcome },
              _react2.default.createElement(
                'div',
                null,
                t('We\'re glad you\'re here')
              ),
              _react2.default.createElement(
                'div',
                { className: 'colorPrimary' },
                (0, _strings.concat)(' ', loginData.name, loginData.surname)
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'colorDark' },
              t('You are just a few clicks away from being able to access your content')
            ),
            _react2.default.createElement(
              'div',
              { className: 'margin-top-40' },
              activateAccountLoaded ? _react2.default.createElement(
                'div',
                { className: 'colorPrimary' },
                _react2.default.createElement(
                  'div',
                  { className: 'h3' },
                  t('Please check your email!')
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  t('We\'ve sent a message to \'{{email}}\' open it up and click Activate Account and we\'ll do the rest.', { email: loginData.email })
                )
              ) : _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_components.TermsAcceptance, { className: 'margin-top-20' }),
                _react2.default.createElement(
                  _components.Button,
                  {
                    type: 'button',
                    className: 'btn-primary margin-top-20',
                    disabled: !termsAccepted,
                    onClick: this.activate,
                    loading: activateAccountLoading
                  },
                  t('Activate account')
                )
              )
            )
          ) : _react2.default.createElement(
            'div',
            { className: styles.hint },
            t('Please create your own unique password now')
          )
        )
      );
    }
  }]);
  return Registration;
}(_react.Component), _class3.propTypes = {
  activateAccount: _propTypes2.default.func,
  activateAccountLoaded: _propTypes2.default.bool,
  activateAccountLoading: _propTypes2.default.bool,
  loginData: _propTypes2.default.object,
  pushState: _propTypes2.default.func,
  t: _propTypes2.default.func,
  termsAccepted: _propTypes2.default.bool
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'activate', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'activate'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = Registration;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Auth/Registration.js
// module id = 2144
// module chunks = 1